import { EXPORT_DIAGNOSTIC_INFORMATION_ENDPOINT } from 'api/ListsApi';
import { useListId } from './useListId';
import { postFormToEndpoint } from '../utils';
import { useSegmentationQueryContext } from '../contexts/segmentationQuery';

export const useExportDiagnosticInfo = () => {
  const listId = useListId()?.toString();
  const { searchQuery } = useSegmentationQueryContext();
  const params = {
    searchQuery,
    ...(listId && { emailListId: listId }),
  };
  return () => postFormToEndpoint(EXPORT_DIAGNOSTIC_INFORMATION_ENDPOINT, params);
};
